module.exports = __webpack_public_path__ + "static/media/RA12.65932b01.gif";